/** @file Editor entry: the api client and server store, mounted through the shell App into #root. */
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createClient } from '@zilo/pose3d-api/client/createClient';
import { artBindings } from './panels/art/artBindings';
import { timelineBindings } from './panels/timeline/timelineBindings';
import { treeBindings } from './panels/tree/treeBindings';
import { viewportBindings } from './panels/viewport/viewportBindings';
import { previewLoader } from './preview/previewLoader';
import { App } from './shell/App';
import { EDITOR_SETTINGS } from './shell/editorSettings';
import { createServerEditorStore } from './store/createServerEditorStore';
import './ui-kit/tokens.css';

const root = document.getElementById('root');
if (root === null) throw new Error('index.html has no #root');
// Empty URL setting = this page's origin: Vite proxies /api (and the live socket) to the Worker.
const client = createClient({ url: EDITOR_SETTINGS.url.load() || window.location.origin });
const store = createServerEditorStore({ client, previewLoader });
createRoot(root).render(<StrictMode><App store={store} client={client} bindingTables={[viewportBindings, treeBindings, timelineBindings, artBindings]} /></StrictMode>);
